var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[(_vm.loading.completed)?_c('div',{attrs:{"id":"header"}},[_c('h1',[_vm._v("Resn Template v3")]),_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/","exact":""}},[_vm._v("Home")])],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }